export default __webpack_public_path__ + "static/media/graph.1838349e.svg";